(($, Drupal, drupalSettings) => {
  Drupal.AjaxCommands.prototype.updateSelectBox = function(ajax, response, status){
    // Vanilla versions of wrap and unwrap
    const unWrap = (els) => {
      els.forEach( el => {
        var parent = el.parentNode;
        while (el.firstChild) parent.insertBefore(el.firstChild, el);
        parent.removeChild(el);
      });
    },
    wrap = (els) => {
      els.forEach( elem => {
        const div = document.createElement('span');
        div.style.display = '';
        elem.parentElement.insertBefore(div, elem);
        div.appendChild(elem);
      });
    }

    // Is there any element?
    var el = document.querySelector(response.selector);
    if (!el){ return; }

    // Loop through new values for select boxes
    Object.keys(response.data).forEach( key => {
      var selectBox = el.querySelector(key),
          hidedElements = [];
      if(selectBox) {
        // Remove wrappers.
        unWrap( selectBox.querySelectorAll('span') );
        if (response.data[key]){
          // Is there new values ?
          Object.keys(response.data[key]).forEach( keyForElem => {
            if (!selectBox.querySelectorAll('option[value="' + keyForElem + '"]').length) {
              var opt = document.createElement('option');
              opt.value = keyForElem;
              opt.innerHTML = response.data[key][keyForElem];
              selectBox.appendChild(opt);
            }
          });

          // And hide all the options that doesnt like this
          for (var i = 0; i < selectBox.options.length; i++) {
            var val = selectBox.options[i].value;
            if (response.data[key][val] === undefined && val !== 'all'){
              hidedElements.push(selectBox.options[i]);

              // Reset selectbox value if hidden value is the current value.
              // This avoids some weird issues when another selectbox triggers an unavailable value.
              if(val == selectBox.value) {
                selectBox.value = 'all';
              }
            }
          }

          // and finally wrap it
          wrap(hidedElements);
        }
      }

    });
  }

})(jQuery, Drupal, drupalSettings);
